import { render, staticRenderFns } from "./EditNewMoneyTable.vue?vue&type=template&id=2964c803&scoped=true"
import script from "./EditNewMoneyTable.vue?vue&type=script&lang=js"
export * from "./EditNewMoneyTable.vue?vue&type=script&lang=js"
import style0 from "./EditNewMoneyTable.vue?vue&type=style&index=0&id=2964c803&prod&lang=css"
import style1 from "./EditNewMoneyTable.vue?vue&type=style&index=1&id=2964c803&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2964c803",
  null
  
)

export default component.exports